import { createAction, props } from '@ngrx/store';
import { WpFixedPages } from '../../types/wordpress/common-data.type';

export const loadFixedPages = createAction(
  '[Fixed Pages] Load FixedPages',
);

export const loadFixedPagesSuccess = createAction(
  '[Fixed Pages] Load FixedPages Success',
  props<{ data: WpFixedPages }>(),
);

export const loadFixedPagesFailure = createAction(
  '[Fixed Pages] Load FixedPages Failure',
  props<any>(),
);
